export default "__VITE_ASSET__DBhyXQPY__"